import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function RetentionRateChart({ data }) {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Évolution du taux de réachat
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Line dataKey="rate" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </CustomCard>
  );
}
